import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
            热门彩种查询
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            覆盖主流彩票彩种，数据实时更新
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 text-center hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-400">{cat.frequency}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}